export default "__VITE_ASSET__97a2a24f__"